import React from "react";

import NeedHelp from '../need-help'

interface AmountToPayProps {
  [key: string]: any
}

const AmountToPay: React.FC<AmountToPayProps> = (props:any) => {

  const membership_form = (window as any).KEW.collections.membership_form[0]

  return (
    <>
      <div className="row">
        <div className="amount-to-pay clearfix box">
          <div className="large-12 columns">
            <h2>Amount to pay</h2>
            { !props.values.selected_membership.direct_debit_message &&
              <p className="larger">Pay by direct debit and get £{(props.values.selected_membership.direct_debit_discount).toFixed(2)} off your membership fee.</p>
            }
            { props.values.selected_membership.direct_debit_message &&
              <p className="larger">{props.values.selected_membership.direct_debit_message}</p>
            }
          </div>
          <div className="medium-6 columns">
            {membership_form.form_type !== 'ingarden' &&
              <>
                <button type="submit" className="btn-cta go" id="m-pay-by-dd-button" tabIndex={0} onClick={() => {
                  props.setFieldValue('payment_type', 'Regular')
                  props.setFieldValue('payment_method', 'DirectDebit')
                  props.submitForm()
                }}>
                  { ((props.values.selected_membership.base_price - props.values.selected_membership.direct_debit_discount + props.values.renewal_donation_added) % 1 === 0) &&
                    <span>
                      Pay £{props.values.selected_membership.base_price - props.values.selected_membership.direct_debit_discount + props.values.renewal_donation_added} by direct debit
                    </span>
                  }
                  { ((props.values.selected_membership.base_price - props.values.selected_membership.direct_debit_discount + props.values.renewal_donation_added) % 1 !== 0) &&
                    <span>
                      Pay £{(props.values.selected_membership.base_price - props.values.selected_membership.direct_debit_discount + props.values.renewal_donation_added).toFixed(2)} by direct debit
                    </span>
                  }
                </button>
                <button type="submit" className="btn-cta go" id="m-pay-by-card-1-button" tabIndex={0} onClick={() => {
                  props.setFieldValue('payment_type', 'Single')
                  props.setFieldValue('payment_method', 'CreditCard/PayPal')
                  props.submitForm()
                }}>
                  {((props.values.selected_membership.base_price + props.values.renewal_donation_added) % 1 === 0) &&
                    <span>
                      Pay £{props.values.selected_membership.base_price + props.values.renewal_donation_added} by card or paypal
                    </span>
                  }
                  {((props.values.selected_membership.base_price + props.values.renewal_donation_added) % 1 !== 0) &&
                    <span>
                      Pay £{(props.values.selected_membership.base_price + props.values.renewal_donation_added).toFixed(2)} by card or paypal
                    </span>
                  }
                </button>
              </>
            }
          </div>
          { membership_form.form_type === 'ingarden' && (membership_form.direct_debit_enabled || membership_form.card_reader_enabled) &&
            <div className="medium-6 columns">
              { membership_form.direct_debit_enabled &&
                <button type="submit" className="btn-cta go" id="m-pay-by-dd-button" tabIndex={0}onClick={() => {
                  props.setFieldValue('payment_type', 'Regular')
                  props.setFieldValue('payment_method', 'DirectDebit')
                }}>
                  { ((props.values.selected_membership.base_price - props.values.selected_membership.direct_debit_discount) % 1 === 0) &&
                    <span>
                      Pay £{props.values.selected_membership.base_price - props.values.selected_membership.direct_debit_discount} by direct debit
                    </span>
                  }
                  { ((props.values.selected_membership.base_price - props.values.selected_membership.direct_debit_discount) % 1 !== 0) &&
                    <span>
                      Pay £{(props.values.selected_membership.base_price - props.values.selected_membership.direct_debit_discount).toFixed(2)} by direct debit
                    </span>
                  }
                </button>
              }
              { membership_form.card_reader_enabled &&
                <button type="submit" className="btn-cta go" id="m-pay-by-card-1-button" tabIndex={0} onClick={() => {
                  props.setFieldValue('payment_type', 'CardReader')
                  props.setFieldValue('payment_method', 'CardReader')
                }}>
                  { props.values.selected_membership.base_price % 1 === 0 &&
                    <span>
                      Pay £{props.values.selected_membership.base_price} by card
                    </span>
                  }
                  { props.values.selected_membership.base_price % 1 !== 0 &&
                    <span>
                      Pay £{(props.values.selected_membership.base_price).toFixed(2)} by card
                    </span>
                  }
                </button>
              }
            </div>
          }
          <div className="medium-6 columns">
            <NeedHelp />
          </div>
        </div>
      </div>
    </>
  );
};

export default AmountToPay;